module.exports = __webpack_public_path__ + "8b588a0a98584fa2d4e9847aa0f50df3.svg";